import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    meshGeometryAttributeSetLike,
    meshGeometryAttributeSetLikeMarker,
    pointGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode, MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeSetLikeNode, MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProductOperatorPairParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"
import {
    GeometryProductOperatorPairNode,
    productOperatorPairParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"

export type MeshGeometryProductOperatorPointGeometryMeshGeometryInputParameters = ProductOperatorPairParameters<
    PointGeometryAttributeLikeNode,
    PointGeometryAttributeSetLikeNode,
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<MeshGeometryProductOperatorPointGeometryMeshGeometryInputParameters> = {
    nodeClass: "MeshGeometryProductOperatorPointGeometryMeshGeometryInput",
    validation: {
        parameters: productOperatorPairParametersSchema(
            pointGeometryAttributeLike,
            pointGeometryAttributeSetLike,
            meshGeometryAttributeLike,
            meshGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryProductOperatorPointGeometryMeshGeometryInput
    extends GeometryProductOperatorPairNode<
        2,
        PointGeometryAttributeLikeNode,
        PointGeometryAttributeSetLikeNode,
        MeshGeometryAttributeLikeNode,
        MeshGeometryAttributeSetLikeNode
    >
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 2 {
        return 2
    }
}
